import {FC, RefObject, useState} from 'react';
import {hasValue} from '@kcast-fe/core';
import {Box} from '@chakra-ui/react';

import {TMemoryView} from '../../MemoryScene';

import {SummaryList, SummaryDetail, SummaryCreateModal} from './components';

interface IProps {
  ref: RefObject<HTMLDivElement | null>;
  currentView: TMemoryView;
  onSetCurrentView: (view: TMemoryView) => void;
}

export const Summaries: FC<IProps> = ({ref, currentView, onSetCurrentView}) => {
  const [id, setId] = useState<string | null>(null);

  const isDetail = currentView === 'summary_view' && hasValue(id);
  const isCreate = currentView === 'summary_create';
  const isList = currentView === 'summary_list';

  const handleBack = () => {
    onSetCurrentView('summary_list');
    setId(null);
  };

  const handleNew = () => {
    onSetCurrentView('summary_create');
    setId(null);
  };

  const handleView = (id: string) => {
    onSetCurrentView('summary_view');
    setId(id);
  };

  return (
    <Box ref={ref} h={'calc(100%)'} overflow={'hidden'}>
      {isList && <SummaryList containerRef={ref} onSelect={handleView} onNew={handleNew} />}
      {isDetail && <SummaryDetail id={id} ref={ref} onDeleted={handleBack} />}
      {isCreate && <SummaryCreateModal ref={ref} onClose={handleBack} onCreated={handleView} />}
    </Box>
  );
};
